export default {
  name: 'responsive-image',
  props: {
    image: {
      type: Object,
      required: true
    },
    maxSize: Number
  },
  render (createElement) {
    if (!this.image) {
      return createElement('span', {
        'class': 'px3 py2 bg-white rounded border border-silver'
      }, 'No image :(')
    }
    const srcset = [
      this.image.sizes.thumbnail,
      this.image.sizes.medium,
      this.image.sizes.medium_large,
      this.image.sizes.large,
      this.image.url
    ]
    let src = srcset[3]
    if (this.maxSize >= 0) {
      src = srcset[this.maxSize]
    }
    return createElement('img', {
      'class': 'lazyload',
      ref: 'picture',
      attrs: {
        'data-src': src
      }
    })
  },
  watch: {
    image (newVal) {
      if (newVal) {
        this.$refs.picture.classList.toggle('lazyloaded')
        this.$refs.picture.classList.toggle('lazyload')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/ResponsiveImage.js